import React from 'react';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../../components/LazyLoadTransition/LazyLoadTransition';
import './About.css';

const START_TIME = 0;
const DURATION_TIME = 3;

const about = () => {
    let animationStarted = false;
    let days;
    let speakers;
    let presentations;
    let labs;
    let attendees;

    const startCounter = () => {
        if (!animationStarted) {
            startAnimation(days);
            startAnimation(speakers);
            startAnimation(presentations);
            startAnimation(labs);
            startAnimation(attendees);
            animationStarted = true;
        }
    };

    return (
        <section className="section" id="about">
            <div className="container">
                <h1 className="section-title about-title">ABOUT</h1>
                <div className="columns is-variable is-8 is-desktop is-multiline">
                    <div className="column is-6-desktop is-12-tablet">
                        <p>
                            OpenSlava 2019 is the 7th edition of one of the largest annual
                            international conferences organized by{' '}
                            <strong>Accenture in Bratislava</strong>.
                        </p>
                        <p>You should consider attending OpenSlava 2019 if you are:</p>
                        <ul>
                            <li>A technology architect or developer</li>
                            <li>An IT consultant</li>
                            <li>An IT student or a teacher from an IT university/faculty</li>
                            <li>
                                Or simply an IT enthusiast interested in the latest trends in open
                                source and emerging digital technologies
                            </li>
                        </ul>
                        <p>
                            OpenSlava 2019 is the annual follow up of the successful OpenSlava
                            2013-2018. Join us and celebrate our 7th OpenSlava anniversary with even
                            more interesting content and inspirational speakers.
                        </p>
                        <p>
                            There will be <strong>NO REGISTRATION FEE</strong> for participation at
                            the conference
                        </p>
                        <p>
                            As OpenSlava evolved to an international event attended by{' '}
                            <strong>top speakers</strong> and participants from all around the
                            globe, the language of the conference is <strong>English</strong>.
                        </p>
                    </div>
                    <div
                        className="column is-hidden-touch is-6-desktop is-12-tablet"
                        id="youtube-column"
                    >
                        <LazyLoadTransition>
                            <div className="background-layer card">
                                <div className="card-image youtube-wrapper">
                                    <iframe
                                        allowFullScreen
                                        frameBorder="0"
                                        src="https://www.youtube.com/embed/j11Ax5dLSIU"
                                        title="yt-video"
                                        width="100%"
                                    />
                                </div>
                                <footer className="footer-wrapper">
                                    <strong>
                                        <p className="card-footer-item">
                                            VIDEO RECORD FROM OPENSLAVA 2019
                                        </p>
                                    </strong>
                                </footer>
                            </div>
                        </LazyLoadTransition>
                    </div>
                </div>

                <LazyLoadTransition>
                    <h1 className="section-title openslava-numbers is-hidden-mobile">
                        OPENSLAVA 2018 IN NUMBERS
                    </h1>
                    <Waypoint onEnter={startCounter}>
                        <div className="columns is-variable is-8 is-desktop is-mobile is-multiline is-hidden-mobile">
                            <div className="column is-2-desktop is-4-tablet is-offset-1-desktop single-stat">
                                <div className="stat">
                                    <CountUp
                                        duration={DURATION_TIME}
                                        end={2}
                                        ref={countUp => {
                                            days = countUp;
                                        }}
                                        start={START_TIME}
                                    />
                                </div>
                                <div className="stat-info">Days</div>
                            </div>
                            <div className="column is-2-desktop is-4-tablet single-stat">
                                <div className="stat">
                                    <CountUp
                                        duration={DURATION_TIME}
                                        end={69}
                                        ref={countUp => {
                                            speakers = countUp;
                                        }}
                                        start={START_TIME}
                                    />
                                </div>
                                <div className="stat-info">Speakers</div>
                            </div>
                            <div className="column is-2-desktop is-4-tablet single-stat">
                                <div className="stat">
                                    <CountUp
                                        duration={DURATION_TIME}
                                        end={40}
                                        ref={countUp => {
                                            presentations = countUp;
                                        }}
                                        start={START_TIME}
                                    />
                                </div>
                                <div className="stat-info">Presentations</div>
                            </div>
                            <div className="column is-2-desktop is-6-tablet single-stat">
                                <div className="stat">
                                    <CountUp
                                        duration={DURATION_TIME}
                                        end={13}
                                        ref={countUp => {
                                            labs = countUp;
                                        }}
                                        start={START_TIME}
                                    />
                                </div>
                                <div className="stat-info">Hands-on Labs</div>
                            </div>
                            <div className="column is-2-desktop is-6-tablet single-stat">
                                <div className="stat">
                                    <CountUp
                                        duration={DURATION_TIME}
                                        end={1150}
                                        ref={countUp => {
                                            attendees = countUp;
                                        }}
                                        start={START_TIME}
                                    />
                                </div>
                                <div className="stat-info">Attendees</div>
                            </div>
                        </div>
                    </Waypoint>
                </LazyLoadTransition>
            </div>
        </section>
    );
};

export default about;
